import { render, staticRenderFns } from "./ResultProject.vue?vue&type=template&id=dafb6706"
import script from "./ResultProject.vue?vue&type=script&lang=ts"
export * from "./ResultProject.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports